export const footNotesHeader = {
  holiday: "Holiday",
  otherFootnotes: "Other Footnotes",
  sickLeave: "Sick Leave",
  vacation: "Vacation"
};
